// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { updateBulkEditState } from 'redux/modules/bulkEdit'

const clearPathAndSiteHighlights = () => (dispatch, getState) => {
  const { bulkEdit } = getState()
  const highlightedPathIds = bulkEdit.get('highlightedPathIds').clear()
  const highlightedSiteIds = bulkEdit.get('highlightedSiteIds').clear()

  return dispatch(updateBulkEditState({
    highlightedSiteIds,
    highlightedPathIds,
  }))
}

export default clearPathAndSiteHighlights
